<template>
    <form class="gs:grid mb-12" action="">
        <div class="sm:col-10 xl:col-11">
            <div class="box box--white box--shadow-lg relative min-h-full">

                <!-- ALERT PAYMENT DECLINED UP MD -->
                <div v-if="err.message" class="alert alert--danger hidden md:block py-3 px-7 absolute t-0 l-0 -mt-16 lg:-mt-22" style="max-width: 445px;">
                   <strong>Error:</strong> {{ err.message }}
                </div>
                <div class="nav_tabs">
                    <!-- NAV CARD -->
                    <div class="nav_item rounded-tl-4" @click.prevent="setActive('Conekta')" :class="{ 'active' : isActive('Conekta') }">
                        <img class="icon_visa mr-4 sm:mr-5" src="/assets/images/helpers/pay_methods/visa.svg"  alt="">
                        <img class="icon_mastercard" src="/assets/images/helpers/pay_methods/mastercard.svg" alt="">
                    </div>
                    <!-- NAV PAYPAL -->
                    <!-- <div class="nav_item" @click.prevent="setActive('Paypal')" :class="{ 'active' : isActive('Paypal') }"> -->
                    <!--     <img class="icon_paypal" src="/assets/images/helpers/pay_methods/paypal.svg"  alt=""> -->
                    <!-- </div> -->
                    <!-- NAV OXXO PAY -->
                    <div class="nav_item rounded-tr-4" @click.prevent="setActive('oxxo_cash')" :class="{ 'active' : isActive('oxxo_cash') }">
                        <img class="icon_oxxopay" src="/assets/images/helpers/pay_methods/oxxopay.svg"  alt="">
                    </div>
                </div>

                <!-- PAYMETHODS -->
                <div class="tab_content h-full px-4 py-7 sm:p-5 lg:px-11 lg:py-13">
                    <!-- TAB PANE CARD -->
                    <div class="tab_pane" v-show="isActive('Conekta')">
                        <p class="tx-12 lg:tx-16 tx-grey-1 weight-500 mb-5 md:mb-9 hidden sm:block">
                            <img class="mr-2" width="11px" src="/assets/images/helpers/pay_methods/securepayment.svg" alt="">
                            Pago seguro con tarjeta de crédito o débito
                        </p>

                        <div class="form-grid">
                            <div class="form-group sm:col-8">
                                <label class="form-label" for="visa_name">
                                    Nombre
                                </label>
                                <input id="visa_name" v-model="visa_name" class="form-input" type="text">
                            </div>
                            <div class="form-group sm:col-8">
                                <label class="form-label" for="visa_number">
                                    Número
                                </label>
                                <the-mask id="visa_number" class="form-input" type="text" v-model="visa_number" placeholder="####-####-####-####" :masked="false" mask="####-####-####-####"></the-mask>
                            </div>
                        </div>

                        <div class="form-grid">
                            <div class="form-group lg:col-8 lg:m-0">
                                <label class="form-label" for="visa_cellphone">
                                    Celular
                                </label>
                                <the-mask class="form-input" type="tel" id="visa_cellphone" v-model="visa_cellphone" placeholder="##-##-##-##-##" :masked="false" mask="##-##-##-##-##"></the-mask>
                            </div>
                            <div class="form-group col-8 sm:col-4 lg:col-2 sm:m-0">
                                <label class="form-label" for="visa_exp_month">
                                    Mes
                                </label>
                                <select id="visa_exp_month" class="form-input" name="visa_exp_month" required v-model="visa_exp_month">
                                    <option value="" style="display:none">Seleccionar</option>
                                    <option value="1">01</option>
                                    <option value="2">02</option>
                                    <option value="3">03</option>
                                    <option value="4">04</option>
                                    <option value="5">05</option>
                                    <option value="6">06</option>
                                    <option value="7">07</option>
                                    <option value="8">08</option>
                                    <option value="9">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </select>
                            </div>
                            <div class="form-group col-8 sm:col-4 lg:col-2 sm:m-0">
                                <label class="form-label" for="visa_exp_year">
                                    Año
                                </label>
                                <select id="visa_exp_year" class="form-input" name="visa_exp_year" required v-model="visa_exp_year">
                                    <option value="" style="display:none">Seleccionar</option>
                                    <option v-for="(year) in getYears()" :key="'year_' + year" :value="'' + year"> {{ year }}</option>
                                </select>

                            </div>
                            <div class="form-group sm:col-8 lg:col-4 sm:m-0">
                                <label class="form-label" for="visa_cvc">
                                    cvc
                                </label>
                                <the-mask class="form-input" type="password" id="visa_cvc" v-model="visa_cvc" placeholder="****" :masked="false" mask="####"></the-mask>
                            </div>
                        </div>
                    </div>

                    <!-- TAB PANE PAYPAL -->
                    <div class="tab_pane" v-show="isActive('Paypal')">
                        <p class="tx-12 lg:tx-16 tx-grey-1 weight-500 my-6 sm:mt-15 mb-0">
                            Tu pago se procesara con paypal
                        </p>
                    </div>
                    <!-- TAB PANE OXXO PAY -->
                    <div class="tab_pane" v-show="isActive('oxxo_cash')">
                        <p class="tx-12 lg:tx-16 tx-grey-1 weight-500 mb-5 md:mb-9 hidden sm:block">
                            <img class="mr-2" width="11px" src="/assets/images/helpers/pay_methods/securepayment.svg" alt="">
                            Pago seguro con Oxxo Pay
                        </p>
                        <div class="form-group p-0 md:col-8">
                            <label class="form-label" for="oxxo_cellphone">
                                Celular
                            </label>
                            <the-mask class="form-input" type="tel" id="oxxo_cellphone" v-model="oxxo_cellphone" placeholder="##-##-##-##-##" :masked="false" mask="##-##-##-##-##"></the-mask>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sm:col-6 xl:col-5 order-first sm:order-last mb-6 sm:mb-0">
            <!-- SUMMARY -->
            <div class="box box--white box--shadow-lg tx-center pt-8 xl:pt-12 px-4 pb-8">
                <div class="mb-6 lg:mb-12">
                    <h2 class="tx-blue-1 tx-24 sm:tx-20 lg:tx-24" v-html="package_info.title" />
                    <p class="tx-12 xl:tx-14 tx-grey-1 mb-4" v-html="'Duración: ' + package_info.duration + ' días'" />
                    <p :class="amount ? 'line-over opacity-20 xl:tx-22' : 'xl:tx-40'" class="tx-30 tx-grey-1 mb-0" v-html="'$ ' + package_info.price + ' MXN'" />
                    <!-- PRICE WHIT DISCOUNT -->
                    <p v-if="amount" class="tx-30 xl:tx-40 tx-grey-1 mb-0" v-html="'$ ' + amount + ' MXN'" />
                </div>

                <p class="tx-10 xl:tx-12 pt-2 tx-orange-1 weight-700 mb-2 uppercase">
                    Código de promoción
                </p>
                <div class="px-3">
                   <!--  INPUT COUPON -->
                    <div class="form-inner">
                        <input class="form-input form-input-helper pr-15" type="text" v-model="cupon">
                        <div v-if="cupon && cupon.length > 0" @click="validateCoupon($event)" class="form-helper r-0 tx-12 tx-orange-1 underline cursor-pointer w-a px-2">
                            Validar
                        </div>
                    </div>
                </div>
                <p v-if="err.cupon" class="tx-10 tx-orange-1 weight-700 mb-2 uppercase mt-2" v-html="err.cupon" >
                <hr class="hidden sm:block mb-6">
                <div class="tx-left fixed sm:relative l-0 b-0 p-4 sm:p-0 w-full bg-white z-3 shadow-4 sm:shadow-none">

                    <!-- BTN PAY CARD -->
                    <div class="flex justify-content-between sm:justify-content-center align-items-center" v-show="isActive('Conekta')">
                        <p class="tx-10 tx-grey-1 weight-500 mb-0 pr-5 sm:hidden">
                            <img class="mr-2 mb-1" width="11px" src="/assets/images/helpers/pay_methods/securepayment.svg" alt="">
                            Pago seguro con tarjeta de crédito o débito
                        </p>
                        <input v-if="!loading" class="btn btn--green btn--checkout tx-12 md:tx-14 xl:tx-16" type="submit" value="Pagar" @click="payMethod($event)">
                    </div>

                    <!-- BTN PAY PAYPAL -->
                    <div class="flex justify-content-between sm:justify-content-center align-items-center" v-show="isActive('Paypal')">
                        <p class="tx-10 tx-grey-1 weight-500 mb-0 pr-5 sm:hidden">
                            Tu pago se procesara con paypal
                        </p>
                        <!-- TEST PAYPAL -->
                        <form class="flex-none" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick">
                            <input type="hidden" name="hosted_button_id" value="BXYZBJABC8MWW">
                            <input class="btn--paypal" type="image" src="/assets/images/helpers/pay_methods/btn-paypal.png" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea.">
                            <img alt="" border="0" src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1">
                        </form>
                    </div>

                    <!-- BTN PAY OXXOPAY -->
                    <div class="flex justify-content-between sm:justify-content-center align-items-center" v-show="isActive('oxxo_cash')">
                        <p class="tx-10 tx-grey-1 weight-500 mb-0 pr-5 sm:hidden">
                            <img class="mr-2 mb-1" width="11px" src="/assets/images/helpers/pay_methods/securepayment.svg" alt="">
                            Pago seguro con Oxxo Pay
                        </p>
                        <input v-if="!loading" class="btn btn--green btn--checkout tx-12 md:tx-14 xl:tx-16" type="submit" value="Pagar en Oxxo" @click="payMethod($event)">
                    </div>

                    <!-- ALERT PAYMENT DECLINED ONLY MD -->
                    <!-- <div class="alert alert--danger py-3 px-4 mt-4 md:hidden">
                        <strong>Tu pago ha sido rechazado.</strong> Verifica tu información o inténtalo nuevamente con un método de pago distinto.
                    </div> -->
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { mapState } from 'vuex';
    import {TheMask} from 'vue-the-mask';
    export default {
        props: ['package', 'product'],
        data() {
            return {
                pay_type: 'Conekta',
                card: {
                    name: '',
                    number: '',
                    cellphone: '',
                    exp_month: '',
                    exp_year: '2022',
                    cvc: '',
                },
                cellphoneMasks: [
                    '##-##-##-##-##'
                ],
                oxxo: {
                    cellphone: '',
                },
                cupon: '',
                user_id: null,
                amount: null,
                years_list: [],
                loading: false,

                formData: null,
                err: {}
            }
        },

        components: {
            TheMask
        },

        computed: {
            ...mapState(['user']),

            package_info: {
                get: function () { return this.package; },
            },
            visa_name: {
                get: function () { return this.card.name; },
                set: function (inputValue) { this.card.name = inputValue.trim(); }
            },
            visa_number: {
                get: function () { return this.card.number; },
                set: function (inputValue) { this.card.number = inputValue.trim(); }
            },
            visa_cellphone: {
                get: function () { return this.card.cellphone; },
                set: function (inputValue) { this.card.cellphone = inputValue.trim(); }
            },
            visa_exp_month: {
                get: function () { return this.card.exp_month; },
                set: function (inputValue) { this.card.exp_month = inputValue.trim(); }
            },
            visa_exp_year: {
                get: function () { return this.card.exp_year; },
                set: function (inputValue) { this.card.exp_year = inputValue; }
            },
            visa_cvc: {
                get: function () { return this.card.cvc; },
                set: function (inputValue) { this.card.cvc = inputValue.trim(); }
            },
            oxxo_cellphone: {
                get: function () { return this.oxxo.cellphone; },
                set: function (inputValue) { this.oxxo.cellphone =  inputValue.trim(); }
            },
        },
        watch: {
            user(state) {
            let vm = this;
            if ( state.id !== undefined ) {
                vm.user_id = state.id;
            }
        }

        },
        methods: {
            isActive(menuItem){
                return this.pay_type === menuItem
            },

            setActive(menuItem){
                this.pay_type = menuItem
            },

            getToken(){
                let vm = this;
                Conekta.token.create({ card: vm.card },
                function(token){
                    vm.formData.append('token',  token.id);

                }, function(response){
                    vm.err.message = response.message_to_purchaser;
                    vm.showErrors();
                    vm.loading = false;
                });
            },

            async payMethod(event) {
                event.preventDefault();
                let vm = this;

                   if( !vm.loading ){
                    vm.resetForms();
                    vm.loading = true;
                    vm.$swal({
                        icon: "info",
                        title: "Procesando...",
                        text: "Espere un momento",
                    });


                    if (vm.pay_type == 'Conekta') {
                        vm.getToken();
                        if(!vm.card.cellphone.startsWith('+')){
                            vm.card.cellphone = '+52' + vm.card.cellphone;
                        }
                        vm.formData.append('phone', vm.card.cellphone);
                    }

                    if (vm.pay_type == 'oxxo_cash') {
                        vm.formData.append('oxxo', JSON.stringify(vm.oxxo) );
                    }

                    if (vm.pay_type == 'Paypal') {
                        vm.formData.append('paypal', JSON.stringify(vm.paypal) );
                    }

                    vm.formData.append('pay_method', vm.pay_type.trim() );
                    vm.formData.append('cupon', vm.cupon.trim() );
                    vm.formData.append('user_id', vm.user_id);
                    vm.formData.append('package_id', vm.package.id);
                    vm.formData.append('product_id', vm.product.id);

                    setTimeout(async function(){
                        if (!vm.err.message) {
                            try {
                                let {data} = await axios.post('/client/payments', vm.formData)
                                .then(response => {

                                    if (vm.pay_type == 'oxxo_cash') {
                                        vm.$swal({
                                            icon: "success",
                                            title: "Referencia OXXO",
                                            text: "Se te mostrará una referencia de pago para que puedas pagar en cualquier OXXO.",
                                            closeOnConfirm: true,
                                            closeOnCancel: true,
                                            confirmButtonText: 'Aceptar'
                                        }).then((result) => {
                                            window.open('/oxxopay/' + response.data.reference, '_blank');
                                            vm.resetValues();
                                            vm.loading = false;
                                            window.location.href = `/mis-anuncios/${vm.product.id}`
                                        });
                                    }
                                    else {
                                        vm.$swal({
                                            icon: "success",
                                            title: "Pago realizado",
                                            text: "Su producto ahora se encuentra en revisión",
                                            closeOnConfirm: true,
                                            closeOnCancel: true,
                                            confirmButtonText: 'Aceptar'
                                        }).then((result) => {
                                            vm.resetValues();
                                            vm.loading = false;
                                            window.location.href = `/mis-anuncios/${vm.product.id}`
                                        });
                                    }
                                }).catch(error => {
                                    vm.showErrors(error);
                                    vm.loading = false;
                                });

                            } catch (error) { }
                        }
                    }, 2000 );
                }
            },

            async validateCoupon(e){
                let vm = this;
                if (vm.cupon) {
                    vm.resetForms();
                    vm.amount = null;
                    vm.formData.append('cupon', vm.cupon.trim() );
                    vm.formData.append('user_id', vm.user_id);
                    vm.formData.append('package_id', vm.package.id);
                    try {
                        let {data} = await axios.post('/client/payments/validate-coupon', vm.formData)
                        .then(response => {
                            vm.amount   = response.data.amount;
                             vm.err.cupon = response.data.cupon ? response.data.cupon : '';
                        }).catch(error => {
                            vm.showErrors(error);
                        });

                    } catch (error) { }
                }

            },

            showErrors(error = null){
                let vm = this;
                if ( error ) {
                    vm.err = error.response.data;
                }
                vm.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: vm.err.message ? vm.err.message : 'Se encontraron algunos errores en el formulario',
                });
            },

            resetForms(){
                let vm = this;
                vm.formData = new FormData();
                vm.err = [];
            },

            resetValues(){
                let vm = this;
                vm.visa_name        = '';
                vm.visa_number      = '';
                vm.visa_cellphone   = '';
                vm.visa_exp_month   = '';
                vm.visa_exp_year    = '';
                vm.visa_cvc         = '';
                vm.oxxo_cellphone   = '';
            },

            getYears() {
                if (this.years_list.length == 0) {
                    let current_year = new Date().getFullYear();
                    for (let index = current_year; index <= current_year + 5; index++) {
                        this.years_list.push(index);
                    }
                }
                return this.years_list;
            }
        },
    }
</script>
